import { render, staticRenderFns } from "./active-stream.vue?vue&type=template&id=2c2df816&scoped=true&"
import script from "./active-stream.vue?vue&type=script&lang=js&"
export * from "./active-stream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2df816",
  null
  
)

export default component.exports